/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BannerLangViewModelPaginatedResponse } from "../types/BannerLangViewModelPaginatedResponse.ts";
import { bannerLangViewModelSchema } from "./bannerLangViewModelSchema.ts";

export const bannerLangViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => bannerLangViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<BannerLangViewModelPaginatedResponse>;
